<template>
  <div class="home pure-g">
    
    <MainMenu class="pure-u-1-6"/>
    
    <div class="pure-u-5-6">
      
      <div class="menuBarBox">
        <div id="menuBar" class="pure-menu pure-menu-horizontal menuBar">

        </div>
      </div>

      <div class="formBox">
        <form class="pure-form pure-form-stacked">
          <fieldset>
            <legend>Inventuren &Uuml;bersicht (Admin)</legend>
            <div class="pure-u-1-1">
              <label for="search">Suche</label>
              <input id="search" class="pure-u-10-24" type="text" v-model="search" v-on:keyup="loadData(url)">
              <select id="idClosed" v-model="selectedClosed" v-on:change="loadData(url)">
                <option value="-"></option>
                <option value="true">Abgeschlossen</option>
                <option value="false">Offen</option>
              </select>
            </div>
          </fieldset>
        </form>
      </div>
      
      <div class="tableBox">
        <div class="pure-menu pure-menu-horizontal tableNav">
          <li id="tableNavFirst" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadData(stocktakings._links.firstPage.href)">&lt;&lt;</a></li>
          <li id="tableNavPrev" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadData(stocktakings._links.prevPage.href)">&lt;</a></li>
          <li class="pure-menu-item">Seite {{ stocktakings.page + 1 }} von {{ stocktakings.pages }} &frasl; Inventuren: {{ stocktakings.total }}</li>
          <li id="tableNavNext" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadData(stocktakings._links.nextPage.href)">&gt;</a></li>
          <li id="tableNavLast" class="pure-menu-item"><a class="pure-menu-link" v-on:click="loadData(stocktakings._links.lastPage.href)">&gt;&gt;</a></li>
        </div>
        <table class="pure-table table">
          <thead>
              <tr> 
                  <th id="colName">Datum</th>
                  <th id="colType">Typ</th>
                  <th id="colStore">Filiale</th>
                  <th id="colClosed">Abgeschl.</th>
                  <th id="colLastCompletion">&Uuml;bertragen am</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="stocktaking in  this.stocktakings.data " :key="stocktaking.stocktakingId">
                  <td>{{ new Date(stocktaking.date).toLocaleDateString('de', { month: '2-digit', day: '2-digit', year: 'numeric' } ) }}</td>
                  <td>{{ stocktaking.customerName }}</td>
                  <td>{{ stocktaking.store }}</td>
                  <td>{{ isClosed(stocktaking.closed) }}</td>
                  <td>{{ getLastCompletionDate(stocktaking.lastCompletionDate) }}</td>
              </tr>
          </tbody>
        </table>
        
      </div>

    </div>  
  </div>
</template>

<script>
import MainMenu from "@/components/MainMenu.vue"
import axios from "axios"
import router from "@/router.js"
import { getJwt } from "@/utils/auth.js"
import PencilIcon from "vue-material-design-icons/pencil.vue"
import DeleteIcon from "vue-material-design-icons/delete.vue"
import { getApiUrl } from '@/utils/api.js'


export default {
  name: "stocktakingAdminView",
  data: function() {
    return {
      stocktakings: [],
      search: "",
      selectedClosed: "",
      url: getApiUrl() + "/v0/stocktakings/admin?size=30&page=0&search="
    };
  },
  components: {
    MainMenu,
    PencilIcon,
    DeleteIcon
  },
  mounted: function() {
    this.loadData(this.url);
  },
  methods: {
    loadData: function(url) {

      url = url + this.search
      if (this.selectedClosed == "true")
        url = url + "&closed=true"
      if (this.selectedClosed == "false")
        url = url + "&closed=true"

      axios({
        method: "GET",
        url: url,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + getJwt()
        }
      }).then(
        result => {
          this.stocktakings = result.data;
        },
        error => {
          console.error(error.response.data.status)
        }
      )
    },
    isClosed: function(closed) {
      if (closed)
        return "X"
      else
        return ""
    },
    getLastCompletionDate: function(lastCompletionDate) {
      if (lastCompletionDate === null)
        return ""
      else
        return new Date(lastCompletionDate).toLocaleTimeString('de', { month: '2-digit', day: '2-digit', year: 'numeric'  } )
    }
  }
};
</script>

<style>

</style>
